import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="footer-inner">
      <nav className="footer-nav">
        <Link to="/terms">Terms</Link>
        <Link to="/privacy">Privacy</Link>
        <Link to="/contact">Contact</Link>
      </nav>
      <div className="footer-copy">
        © LottoLogic LLC. All rights reserved.
      </div>
    </div>
  </footer>
);

export default Footer;
